import React, { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html"; // To convert editor content to HTML

const TextEditor = (props) => {
    const [editorState, setEditorState] = useState(EditorState.createEmpty());

    // Custom onChange handler
    const handleEditorChange = (newState) => {
        setEditorState(newState);

        // Convert content to raw format
        const rawContentState = convertToRaw(newState.getCurrentContent());

        // Convert raw content to HTML
        const htmlContent = draftToHtml(rawContentState);
        props?.setFieldWithEditor && props?.setFieldWithEditor(htmlContent);
    };

    return (
        <div style={{ border: '1px solid black',minHeight: "150px" }}>
            <Editor
                editorState={editorState}
                onEditorStateChange={handleEditorChange}
                toolbarClassName="toolbarClassName"
                wrapperClassName="wrapperClassName"
                editorClassName="editorClassName"
            />
        </div>
    );
};

export default TextEditor;
